module.exports = __webpack_public_path__ + "img/bt.95b75716.svg";